<section class="bio-face-flow" aria-live="polite" [ngSwitch]="screen">
  <ng-container *ngIf="screen === 'FACE_READY' || screen === 'FACE_CAPTURE'">
    <div class="bio-face-camera-stage" [class.bio-face-camera-stage--ready]="screen === 'FACE_READY'">
    <div class="bio-face-instructions">
      <h2>{{ faceTitle }}</h2>
      <p *ngIf="screen === 'FACE_CAPTURE'" class="bio-face-feedback bio-face-position-feedback">{{ facePositionFeedback }}</p>
    </div>
    <div class="bio-face-camera-area">
    <div
      class="bio-face-video-shell"
      [class.bio-face-video-shell--ready]="screen === 'FACE_READY'"
      [class.bio-face-video-shell--challenge]="screen === 'FACE_CAPTURE'"
      [class.bio-face-video-shell--valid]="screen === 'FACE_CAPTURE' && (isFaceBaseValid || isCapturing)"
    >
      <video #video autoplay playsinline muted></video>
      <canvas #canvas class="bio-face-capture-canvas"></canvas>
        <div class="bio-face-mask" aria-hidden="true"></div>
        <div class="bio-face-oval" aria-hidden="true"></div>
        <span class="bio-face-countdown" *ngIf="countdown !== null">{{ countdown }}</span>
        <span class="bio-face-loading-overlay" *ngIf="isStarting" aria-hidden="true"><span class="bio-face-spinner"></span></span>
    </div>
      </div>
      <button *ngIf="screen === 'FACE_READY'" type="button" class="bio-face-primary" (click)="beginDetection()" [disabled]="isStarting">Continuar</button>
    </div>
  </ng-container>

  <div *ngSwitchCase="'VALIDATING'" class="bio-face-panel bio-face-loader">
    <span class="bio-face-spinner" aria-hidden="true"></span>
    <p>Estamos validando tus datos...</p>
  </div>

  <div *ngSwitchCase="'SUCCESS'" class="bio-face-panel bio-face-result">
    <img src="assets/icons/chapita-ok.svg" alt="" />
    <h2>Validamos tu identidad con éxito</h2>
  </div>

  <div *ngSwitchCase="'RETRY_ERROR'" class="bio-face-retry-overlay" [class.bio-face-retry-overlay--failed]="failedValidation" role="alertdialog" aria-modal="true" aria-labelledby="bio-face-retry-title">
    <div class="bio-face-retry-modal" [class.bio-face-retry-modal--failed]="failedValidation">
      <button *ngIf="failedValidation" type="button" class="bio-face-modal-close" (click)="closeFailedSelfie()" aria-label="Cerrar">
        <mat-icon>close</mat-icon>
      </button>
      <img src="assets/icons/alert-error.svg" alt="" />
      <h2 id="bio-face-retry-title">{{ bioErrorTitle }}</h2>
      <p>{{ bioError }}</p>
      <div [class.bio-face-modal-actions]="failedValidation">
        <button *ngIf="failedValidation" type="button" class="bio-face-modal-outline" (click)="closeFailedSelfie()">Cerrar</button>
        <button type="button" class="bio-face-primary" (click)="retryBio()">Reintentar</button>
      </div>
    </div>
  </div>

  <div *ngSwitchCase="'FINAL_ERROR'" class="bio-face-panel bio-face-result">
    <img src="assets/icons/chapita-error.svg" alt="" />
    <div class="bio-face-final-copy">
      <h2>No pudimos completar la validación biométrica.</h2>
      <p>Por favor, ponete en contacto con nosotros para ayudarte a verificar tu cuenta.</p>
    </div>
    <button type="button" class="bio-face-primary" (click)="acceptFinalError()">Aceptar</button>
  </div>

  <div *ngSwitchCase="'CAMERA_ERROR'" class="bio-face-panel bio-face-result">
    <mat-icon>error_outline</mat-icon>
    <h2>No pudimos acceder a la cámara</h2>
    <p>{{ cameraError }}</p>
    <button type="button" class="bio-face-primary" (click)="retryCamera()">Intentar de nuevo</button>
  </div>

  <div *ngSwitchCase="'BIO_TECHNICAL_ERROR'" class="bio-face-panel bio-face-result">
    <img class="bio-face-error-icon" src="assets/icons/alert-error.svg" alt="" />
    <h2>{{ bioErrorTitle }}</h2>
    <p>{{ bioError }}</p>
    <button type="button" class="bio-face-primary" (click)="retryBio()">Intentar de nuevo</button>
  </div>

  <div *ngSwitchCase="'PROCESS_EXPIRED'" class="bio-face-panel bio-face-result">
    <img class="bio-face-error-icon" src="assets/icons/alert-error.svg" alt="" />
    <h2>{{ bioErrorTitle }}</h2>
    <p>{{ bioError }}</p>
    <button type="button" class="bio-face-primary" (click)="acceptFinalError()">Volver al inicio</button>
  </div>

  <div *ngSwitchCase="'PRESIGNED_EXPIRED'" class="bio-face-retry-overlay" role="alertdialog" aria-modal="true" aria-labelledby="bio-face-presigned-expired-title">
    <div class="bio-face-retry-modal">
      <img src="assets/icons/alert-error.svg" alt="" />
      <h2 id="bio-face-presigned-expired-title">{{ bioErrorTitle }}</h2>
      <p>{{ bioError }}</p>
      <button type="button" class="bio-face-primary" (click)="acceptFinalError()">Volver al inicio</button>
    </div>
  </div>
</section>
